import React, { Component } from 'react';
import classnames from 'classnames';

class Modal extends Component {
    submitModal = submitval => {
        this.props.submitAction(submitval);
        this.props.setPRComplete(true);
        this.props.toggleModal();
    };

    render() {
        let modalToggle = classnames('modal-dialog', 'hidden', {
            show: this.props.toggleAction
        });
        return (
            <div className="modal">
                <div className={modalToggle}>
                    <div
                        className="modal-dialog__background"
                        onClick={() => {
                            this.props.toggleModal();
                        }}
                    />
                    <div className="modal-dialog__content">
                        <div className="modal-dialog__inner">
                            <div className="modal-dialog__actions">
                                <button
                                    className="modal-dialog__close"
                                    onClick={() => {
                                        this.props.submitAction('hideModal');
                                        this.props.toggleModal();
                                    }}
                                >
                                    <svg className="icon icon-close">
                                        <use
                                            xmlnsXlink="http://www.w3.org/1999/xlink"
                                            xlinkHref="#icon-close"
                                        />
                                    </svg>
                                </button>
                            </div>
                            {this.props.children}

                            <button
                                className="btn align-right modal-dialog__close"
                                onClick={() => {
                                    this.props.submitAction('hideModal');
                                    this.props.toggleModal();
                                }}
                            >
                                Cancel
                            </button>

                            {this.props.submitAction ? (
                                <button
                                    className="btn btn--submit align-right"
                                    type="submit"
                                    onClick={() => {
                                        this.submitModal('submit');
                                    }}
                                >
                                    Confirm
                                </button>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/ui/modal-pr-confirm.js